'use strict';

var Reach = require('./reach');

var internals = {};

module.exports = function (obj, template, options) {
  return template.replace(/{([^}]+)}/g, function ($0, chain) {
    var value = Reach(obj, chain, options);
    return value === undefined || value === null ? '' : value;
  });
};